/** What the super admin is looking at: the top floating window (title + visible text), or the main desk. */
export function readScreen() {
  const sheet = [...document.querySelectorAll('[role="dialog"][data-state="open"]')].filter((d) => d.getAttribute("data-testid") !== "ally-panel").pop();
  const wins = [...document.querySelectorAll("[data-window-id]")].filter((w) => w.offsetParent !== null || w.getClientRects().length);
  const top = wins.sort((a, b) => (Number(b.style.zIndex) || 0) - (Number(a.style.zIndex) || 0))[0];
  const clean = (el) => {
    if (!el) return "";
    const c = el.cloneNode(true);
    c.querySelectorAll("[data-phi], input[type=password], script, style, svg").forEach((n) => n.remove());
    return (c.innerText || "").replace(/\n{3,}/g, "\n\n").trim().slice(0, 7000);
  };
  if (sheet) {
    const h = sheet.querySelector("h2, [data-testid$=title]");
    return { kind: sheet.getAttribute("data-testid") || "panel", title: (h?.innerText || "Open panel").slice(0, 160), text: clean(sheet), path: window.location.pathname };
  }
  if (top) {
    const kind = (top.getAttribute("data-testid") || "").replace("nds-floating-window-", "") || "window";
    const handle = top.querySelector("[data-testid^=nds-floating-window-handle-]");
    const title = (handle?.innerText || kind).split("\n").map((l) => l.trim()).filter((l) => l && !l.startsWith("//"))[0]?.slice(0, 160) || kind;
    return { kind, title, text: clean(top), path: window.location.pathname };
  }
  const tab = document.querySelector("[data-testid^=nds-window-tab-]");
  if (tab) return { kind: tab.getAttribute("data-testid").replace("nds-window-tab-", ""), title: document.title.replace(" · TEA", "").replace(/^\/\/\s*/, "").split(" · ").pop(), text: clean(tab), path: window.location.pathname };
  return { kind: "desk", title: "Main desk", text: clean(document.querySelector("main") || document.body), path: window.location.pathname };
}
